<p-blockUI *ngIf="loading$ | async" [blocked]="true">
  <div class="flex flex-column align-items-center">
    <p-progressSpinner styleClass="custom-spinner" ariaLabel="loading"></p-progressSpinner>
  </div>
</p-blockUI>
